module.exports = __webpack_public_path__ + "static/media/poznavatkrym.606d25b7.jpg";